import {
  Apartment,
  Assessment,
  AccessibleForward,
  Contacts,
  DirectionsWalk,
} from "@material-ui/icons";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import InfoArea from "components/InfoArea/InfoArea";
import React from "react";
import img1 from "assets/img/ngo.jpeg";
import img2 from "assets/img/bionic.jpeg";
import img3 from "assets/img/bs1.jpeg";
import img5 from "assets/img/hospital.webp";
import img6 from "assets/img/govt.jpeg";
import img4 from "assets/img/bigData.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import CanvaVideo from "./CanvaVideo";
import Fade from "react-reveal/Fade";

const BussinessModel = () => {
  return (
    <div className="container pt-5">
      <Fade top>
        <h2 className="text-center pt-5 my-4">
          Why our Product is need of the hour?
        </h2>
        <CanvaVideo embedId="DAEe2xQZLLc" />
      </Fade>
      <Fade left>
        <img
          // style={{ width: "50%" }}
          src={img3}
          class="img-fluid mx-auto d-flex"
          alt="Responsive image"
        />
        <p className="p-3" style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
          As per the given data by the National Programme for Control of
          Blindness
          {"&"} Visual Impairment(NPCBVI). 1,04,09,383 patients with visual
          impairment handled by 1,255 NGOs and 471 low vison dedicated hospitals
          in India hence. To make their life obstacles free with the power of
          today's technology Drishti is the solution.
        </p>
      </Fade>
      <Fade right>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={6}>
            <InfoArea
              title="For Hospitals and Medical Firms"
              description={`As per NPCBVI in India 𝟰𝟳𝟭 hospital for people with low vison, 𝟯𝟬𝟬 Centers for cure of people with spinal cord injury.\nWe are providing a customized device to hospitals according to their needs. They can use Drishti  for the patients with low vision to empower them with real time realtime obstacle detection and navigation .Hospitals can book it through our website and specify their needs. After their medical verification, we'll provide them custom 'Drishti' devices with personal assistance for its efficient use.`}
              icon={Apartment}
              iconColor="rose"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <img
              style={{ width: "50%" }}
              src={img5}
              class="img-fluid mx-auto d-flex"
              alt="Responsive image"
            />
          </GridItem>
        </GridContainer>
      </Fade>
      <br />
      <br />
      <br />
      <Fade left>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={6}>
            <img
              style={{ width: "50%" }}
              src={img1}
              class="img-fluid mx-auto d-flex"
              alt="Responsive image"
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <InfoArea
              title="For NGO’s"
              description={`As per NPCBVI in India 𝟭𝟮𝟱𝟱 NGO's in India with a good doantion woriking for low vison people, \nWe are providing a device at a low cost to NGOs. They can use Drishti  for the patients with low vision to empower them with real time realtime obstacle detection and navigation .NGO can book it through our website and specify their needs. After their medical verification, we'll provide them custom 'Drishti' devices with personal assistance for its efficient use.`}
              icon={AccessibleForward}
              iconColor="rose"
              vertical
            />
          </GridItem>
        </GridContainer>
      </Fade>
      <br />
      <br />
      <br />
      <Fade right>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={6}>
            <InfoArea
              title="For Government Medical Schemes"
              description="We are considering tying up with the government to provide our product at a subsidized rate for those who can't afford it. Our revolutionary product can make a considerable change in their lives. Devices will be distributed at government health camps according to the need of the person and our team will assist them in using it efficiently."
              icon={Contacts}
              iconColor="default"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <img
              style={{ width: "50%" }}
              src={img6}
              class="img-fluid mx-auto d-flex"
              alt="Responsive image"
            />
          </GridItem>
        </GridContainer>
      </Fade>
      <br />
      <br />
      <br />
      <Fade left>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={6}>
            <img
              style={{ width: "50%" }}
              src={img2}
              class="img-fluid mx-auto d-flex"
              alt="Responsive image"
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <InfoArea
              title="For Bionic Firms Companies"
              description="We can also collaborate with various bionic firms to integrate our device with some of their products like bionic limbs to make them smarter which can prove to be very helpful to the users. Our obstacle detection module can help in better movement of artificial limbs according to any obstacle to help an impaired person in safe navigation."
              icon={DirectionsWalk}
              iconColor="rose"
              vertical
            />
          </GridItem>
        </GridContainer>
      </Fade>
      <br />
      <br />
      <br />
      <Fade right>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={6}>
            <InfoArea
              title="For Big Data Clients"
              description="Apart from our product we also intend to sell loads of data generated by thousands of such devices to Big Data firms involved in navigation and path mapping. The data regarding permanent obstacles detected by our devices can be sold to firms like Google as it can help make their services like Google Maps more informative and useful."
              icon={Assessment}
              iconColor="default"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <img
              style={{ width: "50%" }}
              src={img4}
              class="img-fluid mx-auto d-flex"
              alt="Responsive image"
            />
          </GridItem>
        </GridContainer>
      </Fade>
      <br />
      <br />
      <br />
    </div>
  );
};

export default BussinessModel;
